import React from 'react';

const Vermont = () => (
  <svg
    width="22"
    height="43"
    viewBox="0 0 22 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5387 40.6696C15.0116 40.5569 12.8221 41.782 9.83706 42.2045C8.83031 36.966 8.46426 28.7 4.71889 27.8692C5.50035 25.2148 3.0574 23.0251 2.67019 20.7016C2.5153 19.7652 3.17711 18.4415 3.18415 17.6318C3.18415 16.9136 2.85323 15.1393 2.67019 14.5619C2.3745 13.6325 1.45929 12.8721 1.13544 11.9991C0.917195 11.4076 1.26216 10.5698 1.13544 9.95016C0.839753 8.4927 -0.0754753 7.19013 0.114609 5.85237C6.72531 3.9302 13.3079 1.97988 20.5944 0.733643C21.2984 2.28264 20.348 2.56427 20.5944 4.83144C21.038 6.4438 21.6575 6.61278 21.6153 7.90127C21.5378 10.4642 18.3909 11.6611 17.5179 13.534C19.475 18.019 16.5041 22.666 16.49 26.8483C16.483 28.7705 17.9896 32.1782 18.0248 35.0368C18.0529 37.0365 17.1518 38.6629 18.5387 40.6696Z"
      fill="#FC374D"
    />
  </svg>
);
export default Vermont;
